import { NULL_UUID_ID } from '@/constants'
import { stockImportsApi } from '@/pages/Exchanges/tabs/StockImports/api/stockImportsApi'
import {
  StoreModel,
  UpdateStoreRequest,
} from '@/pages/Exchanges/tabs/StockImports/types/stockImports.types'

export const resolveStoreStatusId = async (
  store: StoreModel | null,
  stores: StoreModel[]
): Promise<string | undefined> => {
  const fromStore = store?.storeStatusModel?.id
  if (fromStore) return fromStore

  const fromList = stores.find((item) => item.storeStatusModel?.id)
    ?.storeStatusModel?.id
  if (fromList) return fromList

  return (await stockImportsApi.getStoreStatuses())[0]?.id
}

export const buildStoreSupplierUpdatePayload = (
  store: StoreModel,
  storeStatusId: string,
  productSupplierId: string
): UpdateStoreRequest => ({
  owner: store.owner,
  description: store.description,
  address: store.address ?? '',
  contactPersons: store.contactPersons ?? '',
  isRemote: store.isRemote ?? false,
  isActive: store.isActive ?? true,
  storeStatus: storeStatusId,
  comment: store.comment ?? '',
  productSupplierId,
  etaMinDays: store.etaMinDays,
  etaMaxDays: store.etaMaxDays,
  etaCutoffTime: store.etaCutoffTime,
})

export const isStoreUnassigned = (store: StoreModel) => {
  const supplierId = store.productSupplierShortDto?.id
  return !supplierId || supplierId === NULL_UUID_ID
}

export const STORE_DEACTIVATION_CONFIRM_TEXT =
  'Склад станет неактивным. Если к нему привязана загрузка остатков, она будет поставлена на паузу (статус «Черновик»), а остатки склада удалены из поиска. После включения склада загрузку нужно будет активировать вручную.'

export const isStoreDeactivation = (
  store: Pick<StoreModel, 'isActive'> | null,
  values: Pick<StoreModel, 'isActive'>
) => Boolean(store?.isActive) && values.isActive === false
